/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsButtonProps, CmsButtonPropsSchema } from './cms-button'
import {
  type ProductCategories,
  ProductCategoriesSchema,
} from './product-category'

/* TypeScript */
export type AnimatedProductCheckpointsProps = {
  technicalName?: string
  title?: string
  subtitle?: string
  categories: ProductCategories
  button?: CmsButtonProps
}

/* Schemas */
export const AnimatedProductCheckpointsPropsSchema = z.object({
  technicalName: z.string().optional(),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  categories: ProductCategoriesSchema,
  button: CmsButtonPropsSchema.optional(),
})

/* Schemas validation */
type TestAnimatedProductCheckpointsProps = ExpectTrue<
  Equal<
    AnimatedProductCheckpointsProps,
    z.infer<typeof AnimatedProductCheckpointsPropsSchema>
  >
>
